module.exports =
  className: 'modalize scontact-modal'
  dimensions: width: '470px'
